import { useQuery, UseQueryOptions } from 'react-query';
import { BranchesService } from '../../services';
import { ICarrierLocation } from '../../interfaces';

export const useCarrierLocations = (slug: string, options?: UseQueryOptions<ICarrierLocation[], Error, ICarrierLocation[], [string, string]>) => {
  return useQuery<ICarrierLocation[], Error, ICarrierLocation[], [string, string]>(
    ['carrier-locations', slug],
    async () => {
      const result = await BranchesService.getCarrierLocations(slug);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    { staleTime: 5 * 60 * 1000, ...options },
  );
};
